import React, { PureComponent } from 'react';
import { withRouter } from 'react-router';
import renderEnvComponent from 'data/common/renderEnvComponent';
import PropTypes from 'prop-types';
import BasicForm from './BasicForm';
import Airzone from './Airzone';

class AirzoneProductDetail extends PureComponent {
    static propTypes = {
        moduleType: PropTypes.string.isRequired
    };

    render() {
        const { moduleType } = this.props;

        const detailContentByType = {
            airzone: () => <Airzone {...this.props} />,
            default: () => null
        };
        return <BasicForm {...this.props}>{(detailContentByType[moduleType] || detailContentByType['default'])()}</BasicForm>;
    }
}
export default withRouter(renderEnvComponent('scenes/Products/components/Product/Airzone/index', AirzoneProductDetail));



// WEBPACK FOOTER //
// ./environments/genericEnv/scenes/Products/components/Product/Airzone/index.js